enum ProjectAction {
  FETCH_ALL = 'projects/fetchAll',
  ADD_PROJECT = 'projects/addProject',
  UPDATE_PROJECT_DETAILS = 'projects/updateProjectDetails',
  GET_PROJECT = 'projects/getOneProject',
  GET_PROJECT_TABLE = 'getProjectTable'
}

export default ProjectAction;
